import { camelizeResource, pascalizeResource } from '../../helpers/resource';

export const toRegister = pascalizeResource;
export const fromRegister = camelizeResource;



// WEBPACK FOOTER //
// ./src/resources/app/normalizers.js